import { keys, startCase, forOwn, isEmpty, indexOf, split, pullAll, each, remove, find, replace, uniq, toUpper, flatten } from 'lodash';

const filterConfigColumns = (response = {}, readInSections = [], incSection = false, editable = false, alt = false, size = true) => {
    // Add items to this list that you do not want displayed

    let filter = [
        'activeFlag',
        'employeeId',
        'id',
        'pepId',
        // 'type',
    ];

    // Used for comparison on section columns, need to make this more efficient eventually.
    // const sectionList = readInSections()
    const sectionList = readInSections;
    const districtList = isDistrict(sectionList); // Try to future proof the comparison

    // Gather header names
    // Check to see if headers are seperated from row-data where header key will equal row-data field_name
    // Not full map included in header, will use as a lookup.
    let empIdHeader = [];
    if (response.data.Header) {
        empIdHeader = response.data.Header;
    }

    let inKeys = [];
    if (response.data.Data) {
        inKeys = keys(response.data.Data[0]);
    } else {
        inKeys = keys(response.data[0]);
    }
    // Try to track group / child creation blindly
    let tmpCnt = 0;
    let tmpLastGroupName = '';
    let tmpGroupHolder = []; // Now not blindly
    let estWidth = 0;

    const columnNames = inKeys.map(inName => {
        // eslint-disable-line
        const strCaseHeaderName = startCase(inName);
        const doHide = filter.indexOf(inName) > -1; // If columnname exists in the filter array mark hide = true
        // Column definitions
        switch (inName) {
            case 'taxName': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    editable,
                    suppressSizeToFit: size,
                };
            }
            case 'defaultRate': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    hide: doHide,
                    editable,
                    suppressSizeToFit: size,
                };
            }
            case 'allocateTo': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    hide: doHide,
                    editable,
                    suppressSizeToFit: size,
                };
            }
            case 'id': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'pepId': {
                return ({
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    hide: doHide,
                    suppressSizeToFit: size,
                })
            } 
            case 'fundingType': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    editable: editable,
                    width: 75,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'programType': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    editable: editable,
                    width: 250,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'productType': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    editable: editable,
                    width: 250,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'sectionCode': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    minWidth: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'orgCode': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 125,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'branchOrg': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'divisionOrg': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'code': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 50,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'drawOrder': {
                return ({
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 50,
                    hide: doHide,
                    suppressSizeToFit: size,
                })
            }   
            case 'branchCode': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 120,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'divisionCode': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 120,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'officeCode': {
                return {
                    headerName: alt ? 'Office' : strCaseHeaderName,
                    headerTooltip: alt ? 'Office' : strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'empSectionCode': {
                return {
                    headerName: alt ? 'Employee Section' : strCaseHeaderName,
                    headerTooltip: alt ? 'Employee Section' : strCaseHeaderName,
                    field: inName,
                    width: 150,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'employeeId': {
                return {
                    headerName: alt ? 'Emp ID' : strCaseHeaderName,
                    headerTooltip: alt ? 'Emp ID' : strCaseHeaderName,
                    field: inName,
                    width: 75,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'activeFlag': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 50,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'officeId': {
                return {
                    headerName: alt ? 'Office' : strCaseHeaderName,
                    headerTooltip: alt ? 'Office' : strCaseHeaderName,
                    field: inName,
                    width: 80,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'name': {
                return {
                    headerName: alt ? 'Name' : strCaseHeaderName,
                    headerTooltip: alt ? 'Name' : strCaseHeaderName,
                    field: inName,
                    width: 300,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'categoryName': {
                return ({
                    headerName: (alt) ? 'Category' : strCaseHeaderName,
                    headerTooltip: (alt) ? 'Category' : strCaseHeaderName, 
                    field: inName, 
                    width: 150, 
                    hide: doHide,
                    suppressSizeToFit: size,
                })
            }     
            case 'title': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'location': {
                return {
                    headerName: alt ? 'Location' : strCaseHeaderName,
                    headerTooltip: alt ? 'Location' : strCaseHeaderName,
                    field: inName,
                    width: 150,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'empName': {
                return {
                    headerName: alt ? 'Name' : strCaseHeaderName,
                    headerTooltip: alt ? 'Name' : strCaseHeaderName,
                    field: inName,
                    width: 250,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'firstName': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'lastName': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'displayName': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 175,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'empOrgCode': {
                return {
                    headerName: alt ? 'Org Code' : strCaseHeaderName,
                    headerTooltip: alt ? 'Org Code' : strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'empFoaCode': {
                return {
                    headerName: alt ? 'FOA' : strCaseHeaderName,
                    headerTooltip: alt ? 'FOA' : strCaseHeaderName,
                    field: inName,
                    width: 75,
                    hide: doHide,
                    suppressSizeToFit: size,
                    // cellStyle: {
                    //     textAlign: 'center'
                    // },
                };
            }
            case 'empPhone': {
                return {
                    headerName: alt ? 'Phone' : strCaseHeaderName,
                    headerTooltip: alt ? 'Phone' : strCaseHeaderName,
                    field: inName,
                    width: 130,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'empEmailAddr': {
                return {
                    headerName: alt ? 'Email' : strCaseHeaderName,
                    headerTooltip: alt ? 'Email' : strCaseHeaderName,
                    field: inName,
                    width: 275,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'grade': {
                return {
                    headerName: alt ? 'GS' : strCaseHeaderName,
                    headerTooltip: alt ? 'GS' : strCaseHeaderName,
                    field: inName,
                    width: 65,
                    hide: doHide,
                    suppressSizeToFit: size,
                    // cellStyle: {
                    //     textAlign: 'center'
                    // },
                };
            }
            case 'gs': {
                return {
                    headerName: 'GS',
                    headerTooltip: 'GS',
                    field: inName,
                    width: 40,
                    hide: doHide,
                    suppressSizeToFit: size,
                    cellStyle: {
                        textAlign: 'center',
                    },
                };
            }
            case 'rate': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    // width: 60,
                    minWidth: 60,
                    hide: doHide,
                    suppressSizeToFit: size,
                    cellStyle: {
                        textAlign: 'center',
                    },
                };
            }
            case 'overheadRate': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 60,
                    hide: doHide,
                    suppressSizeToFit: size,
                    cellStyle: {
                        textAlign: 'center',
                    },
                };
            }
            case 'type': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 125,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'lineItem': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 500,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'resourceType': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 250,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'status': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'description': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 500,
                    hide: doHide,
                    editable: editable,
                    suppressSizeToFit: size,
                    cellEditor: 'agLargeTextCellEditor',
                    cellEditorPopup: true,
                    cellEditorParams: {
                        maxLength: 2000,
                    },
                };
            }
            case 'normal': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 500,
                    hide: doHide,
                    editable: editable,
                    suppressSizeToFit: size,
                    cellEditor: 'agLargeTextCellEditor',
                    cellEditorPopup: true,
                    cellEditorParams: {
                        maxLength: 2000,
                    },
                };
            }
            case 'lastRefreshDate': {
                return {
                    headerName: alt ? 'Last' : strCaseHeaderName,
                    headerTooltip: alt ? 'Last' : strCaseHeaderName,
                    field: inName,
                    width: 150,
                    hide: doHide,
                    suppressSizeToFit: size,
                    // cellStyle: {
                    //     textAlign: 'center'
                    // },
                };
            }
            case 'effectiveDate': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 150,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'anticipatedRestorationDate': {
                return {
                    headerName: alt ? 'Anticipated' : strCaseHeaderName,
                    headerTooltip: alt ? 'Anticipated' : strCaseHeaderName,
                    field: inName,
                    width: 150,
                    hide: doHide,
                    suppressSizeToFit: size,
                    // cellStyle: {
                    //     textAlign: 'center'
                    // },
                };
            }
            case 'fteHours': {
                return {
                    headerName: 'FTE Hours',
                    headerTooltip: 'FTE Hours',
                    field: inName,
                    width: 80,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'sourceHours': {
                return {
                    headerName: alt ? 'Source Hours' : strCaseHeaderName,
                    headerTooltip: alt ? 'Source Hours' : strCaseHeaderName,
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'ftePct': {
                return {
                    headerName: 'FTE Percent',
                    headerTooltip: 'FTE Percent',
                    field: inName,
                    width: 100,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'notes': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 300,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'sectionCodeHier': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 600,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }
            case 'orgCodeHier': {
                return {
                    headerName: strCaseHeaderName,
                    headerTooltip: strCaseHeaderName,
                    field: inName,
                    width: 600,
                    hide: doHide,
                    suppressSizeToFit: size,
                };
            }

            default: {
                let tmpInName = inName;
                forOwn(empIdHeader, (value, key) => {
                    if (inName === key) {
                        return (inName = value);
                    }
                });

                const tmpIsOs = isOfficeSymbol(inName, districtList); //

                if (tmpIsOs.isbool && incSection === true) {
                    let tmpSplitNames = split(inName, ' ', 10);

                    forOwn(tmpSplitNames, (value, key) => {
                        isEmpty(value) ? (tmpSplitNames[key] = '') : (tmpSplitNames[key] = value);
                    });

                    if (indexOf(tmpSplitNames[0], '-') === -1) {
                        if (tmpIsOs.group !== tmpSplitNames[0]) {
                            tmpSplitNames[0] = tmpIsOs.group;
                        }
                        let tmpIdx = split(tmpIsOs.group, ' ');
                        tmpSplitNames = pullAll(tmpSplitNames, tmpIdx);
                    }

                    let tmpHeaderName = '';
                    let ctrlColGroupShow = 'open';
                    let tmpStructure = {};

                    if (tmpLastGroupName !== tmpSplitNames[0]) {
                        if (!isEmpty(tmpLastGroupName) && tmpLastGroupName !== tmpSplitNames[0] && tmpGroupHolder.indexOf(tmpSplitNames[0]) === -1) {
                            tmpCnt = 0;
                        }
                        tmpLastGroupName = tmpSplitNames[0];
                    }
                    tmpCnt++;
                    if (tmpCnt === 1 && tmpGroupHolder.indexOf(tmpSplitNames[0] === -1)) {
                        tmpGroupHolder.push(tmpSplitNames[0]);
                        tmpHeaderName = estHeader(sectionList, tmpSplitNames);
                        let estWidth;
                        tmpSplitNames[0].length > tmpHeaderName.length ? (estWidth = estColLength(`${tmpSplitNames[0]}`)) : (estWidth = estColLength(`${tmpHeaderName}`));
                        tmpStructure = {
                            headerName: tmpSplitNames[0],
                            groupId: tmpSplitNames[0],
                            openByDefault: true,
                            marryChildren: true,
                            width: estColLength(`${tmpSplitNames[0]}`),
                            children: [
                                {
                                    joinOn: tmpSplitNames[0],
                                    headerName: `${tmpHeaderName}`,
                                    field: tmpInName,
                                    width: estWidth,
                                    editable: editable,
                                    hide: false,
                                    cellStyle: {
                                        textAlign: 'center',
                                    },
                                },
                            ],
                        };
                    } else {
                        tmpHeaderName = estHeader(sectionList, tmpSplitNames);
                        estWidth = estColLength(`${tmpHeaderName}`);
                        tmpStructure = {
                            joinOn: tmpSplitNames[0],
                            headerName: `${tmpHeaderName}`,
                            field: tmpInName,
                            width: estWidth,
                            editable: editable,
                            hide: false,
                            columnGroupShow: `${ctrlColGroupShow}`,
                            filter: 'agNumberColumnFilter',
                            cellStyle: {
                                textAlign: 'center',
                            },
                        };
                    }
                    return tmpStructure;
                    //}
                } else {
                    const tmpIsOC = isOfficeCode(sectionList, tmpInName);
                    estWidth = estColLength(`${tmpIsOC}`, false);
                    return {
                        headerName: tmpIsOC,
                        field: tmpInName,
                        width: estWidth,
                        editable: editable,
                        hide: false,
                    };
                }
            }
        }
    });
    if (incSection === true) {
        return processSections(columnNames);
    } else {
        return columnNames;
    }
};
const processSections = columnDefs => {
    let tmpDefChildren = [];
    each(columnDefs, colValue => {
        if (isEmpty(colValue.children) && !isEmpty(colValue.joinOn)) {
            tmpDefChildren.push(colValue);
        }
    });
    remove(columnDefs, tmpDefChildren => {
        return columnDefs.joinOn !== tmpDefChildren.joinOn;
    });
    each(tmpDefChildren, tmpValue => {
        find(columnDefs, obj => {
            if (obj.headerName === tmpValue.joinOn) {
                return obj.children.push(tmpValue);
            }
        });
    });
    return columnDefs;
};

const estColLength = (inFieldName = '') => {
    const inLen = inFieldName.length;
    switch (true) {
        case inLen <= 3: {
            return inLen * 22;
        }
        case inLen <= 5 && inLen > 3: {
            return inLen * 18;
        }
        case inLen <= 10 && inLen > 5: {
            return inLen * 14;
        }
        case inLen <= 15 && inLen > 10: {
            return inLen * 13;
        }
        case inLen <= 20 && inLen > 15: {
            return inLen * 11;
        }
        case inLen <= 30 && inLen > 20: {
            return inLen * 11;
        }
        default: {
            return inLen * 10;
        }
    }
};

const estHeader = (sectionList, tmpSplitNames) => {
    let tmpHeaderName = '';
    if (sectionList.indexOf(tmpSplitNames[3]) > -1) {
        return `${tmpSplitNames[1]} ${replace(tmpSplitNames[2], ',', '')}`;
    } else {
        forOwn(tmpSplitNames, (value, key) => {
            if (!isEmpty(value) && key > 0) {
                tmpHeaderName += `${tmpSplitNames[key]} `;
            }
        });
    }
    return tmpHeaderName;
};
// TODO: Fix for EIT Codes
const isOfficeCode = (sectionList, inHeader = '') => {
    let tmpOfficeCode = '';
    let tmpDistrict = [];
    let outHeader = inHeader;

    each(sectionList, value => {
        tmpDistrict.push(split(value, '-', 1));
    });
    tmpDistrict = uniq(flatten(tmpDistrict));
    tmpOfficeCode = replace(toUpper(startCase(inHeader)), new RegExp('[ ]', 'g'), '-');

    if (indexOf(tmpDistrict, split(tmpOfficeCode, '-', 1)[0]) > -1) {
        outHeader = tmpOfficeCode;
    }
    const testValue = replace(toUpper(startCase(tmpOfficeCode)), new RegExp('[-]', 'g'), ' ');
    if (indexOf(tmpDistrict, testValue) > -1) {
        outHeader = testValue;
    }
    return outHeader;
};

const isOfficeSymbol = (inName = '', inDistricts = []) => {
    let tmpDist = [];
    const tmpInColPart = split(toUpper(startCase(inName)), ' ', 1);

    if (indexOf(inDistricts, tmpInColPart[0]) === -1) {
        each(inDistricts, value => {
            tmpDist = split(value, ' ');
            if (tmpDist[0] === tmpInColPart[0]) {
                each(tmpDist, (value, key) => {
                    if (key === 0) {
                        tmpInColPart[0] = value;
                    } else {
                        tmpInColPart[0] += ` ${value}`;
                    }
                });
            }
        });
    }
    return indexOf(inDistricts, tmpInColPart[0]) > -1 ? { isbool: true, group: tmpInColPart[0] } : { isbool: false, group: tmpInColPart[0] };
};

const isDistrict = (inSections = []) => {
    let tmpDistrict = [];
    each(inSections, value => {
        tmpDistrict.push(split(value, '-', 1));
    });
    tmpDistrict = uniq(flatten(tmpDistrict));
    return tmpDistrict;
};

export default filterConfigColumns;
